/**
 * Structured Data Component
 * Injects JSON-LD structured data into the page head
 */

import {Helmet} from 'react-helmet-async';
import type {StructuredData} from '@/shared/types/seo.types';

interface StructuredDataProps {
  data: StructuredData | StructuredData[];
}

export function StructuredDataComponent({ data }: StructuredDataProps): React.ReactElement {
  const dataArray = Array.isArray(data) ? data : [data];

  return (
    <Helmet>
      {dataArray.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
